import { useState, useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import SwiperCore from 'swiper';
import { useMediaQuery, useTheme } from '@mui/material';
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';
import { Thumbs } from 'swiper/modules';
import Image from 'next/image';
import 'swiper/css';
import 'swiper/css/thumbs';
import { AudioPlayer, MuiIconButton, VideoPlayer } from '@/components';

const MediaSlider = ({ mediaAssets, isMobile, Complementarytext }: any) => {
  const [mainSwiper, setMainSwiper] = useState<SwiperCore | null>(null);
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperClass | null>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [startIndex, setStartIndex] = useState(0);

  const theme = useTheme();
  const isMobilee = useMediaQuery(theme.breakpoints.down('sm'));
  const [playing, setPlaying] = useState(false);
  const [audioplaying, SetAudioPlaying] = useState(false);
  const playerRef: any = useRef(null);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const visibleThumbnails = isMobilee ? 4 : 5;

  useEffect(() => {
    if (activeIndex >= startIndex + visibleThumbnails - 1) {
      setStartIndex((prev) => Math.min(prev + 1, mediaAssets.length - visibleThumbnails));
    } else if (activeIndex <= startIndex && startIndex > 0) {
      setStartIndex((prev) => Math.max(prev - 1, 0));
    }
  }, [activeIndex, mediaAssets.length]);

  const handleSlideChange = (index: number) => {
    if (playerRef.current) {
      setPlaying(!playing);
    }
    SetAudioPlaying(!audioplaying);
    mainSwiper?.slideTo(index);
    setActiveIndex(index);
  };
  const handleLeftClick = () => {
    if (playerRef.current) {
      setPlaying(!playing);
    }
    SetAudioPlaying(!audioplaying);

    mainSwiper?.slidePrev();
  };
  const handleRightClick = () => {
    if (playerRef.current) {
      setPlaying(!playing);
    }
    SetAudioPlaying(!audioplaying);
    mainSwiper?.slideNext();
  };

  return (
    <>
      <Box
        display='flex'
        flexDirection='column'
        width={isMobilee ? '100%' : '80%'}
        maxWidth={isMobilee ? '100%' : '80%'}
        mt={isMobilee ? '10px' : '15px'}
        maxHeight={isMobilee ? '100%' : '100%'}
        alignItems={'center'}
        justifyContent={'center'}
        position={'relative'}
        sx={{ display: 'flex' }}>
        {!isMobilee && mediaAssets.length > 1 && (
          <MuiIconButton
            disableRipple
            sx={{
              position: 'absolute',
              maxWidth: '420px',
              margin: 'auto',
              left: '-80px',
              top: '50%',
              transform: 'translateY(-50%)',
              backgroundColor: 'transparent',
              border: '1px solid #0171CE',
              width: '68px',
              height: '68px',
              padding: '10px',
              fontSize: '20px',
              cursor: 'pointer',
              zIndex: 10,
              borderRadius: '50%',
              boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
            }}
            method={handleLeftClick}
            icon='/icons/arrow-left'
            altIcon='left'
            iconWidth={24}
            iconHeight={24}
          />
        )}

        {/* Main Swiper */}
        <Swiper
          modules={[Thumbs]}
          spaceBetween={10}
          slidesPerView={1}
          thumbs={thumbsSwiper && !thumbsSwiper.destroyed ? { swiper: thumbsSwiper } : undefined}
          onSwiper={setMainSwiper}
          onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
          style={{
            maxWidth: isMobilee ? '100%' : '100%',
            width: isMobilee ? '100%' : '100%',
            height: '100%',
            maxHeight: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          {mediaAssets.map((item: any, index: any) => (
            <SwiperSlide key={index} className='swiper-slide-thumb'>
                              <Box
                  display='flex'
                  justifyContent='center'
                  alignItems='center'
                  sx={{
                    width: '100%',
                    minHeight: isMobilee ? '45vh' : '60vh',
                    maxHeight: isMobilee ? '60vh' : '100%',
                  }}>
              {item.type === 'video' ? (

                  <VideoPlayer
                    ref={playerRef}
                    hideControls={false}
                    url={item?.src}
                    playingg={playing}
                    style={{
                      maxWidth: '100%',
                      maxHeight: '100%',
                      objectFit: 'contain',
                    }}
                  />
              ) : item.type === 'audio' ? (

                  <AudioPlayer
                    ref={audioRef}
                    hideDelete={true}
                    name={item?.src?.split('/').pop()}
                    audioplaying={audioplaying}
                    audioData={item?.src}
                  />
              ) : item.type === 'image' ? (
  <Image
    src={item.src}
    alt={`Main Image ${index}`}
    priority
    fetchPriority="high"
    unoptimized
    fill
    style={{
    objectFit:'contain',
      borderRadius: 8,
    }}
  />

              ) : null}
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>

        {!isMobilee && mediaAssets.length > 1 && (
          <MuiIconButton
            disableRipple
            sx={{
              position: 'absolute',
              right: '-80px',
              top: '50%',
              transform: 'translateY(-50%)',
              backgroundColor: 'transparent',
              border: '1px solid #0171CE',
              padding: '10px',
              fontSize: '20px',
              cursor: 'pointer',
              zIndex: 10,
              width: '68px',
              height: '68px',
              borderRadius: '100px',
            }}
            method={handleRightClick}
            icon='/icons/arrow-right'
            altIcon='right'
            iconWidth={24}
            iconHeight={24}
          />
        )}
      </Box>

      {/* Thumbnail Swiper */}
      {mediaAssets.length > 1 && (
        <Box
          position='relative'
          width={isMobilee ? '358px' : '80%'}
          maxWidth={isMobilee ? '358px' : '80%'}
          display='flex'
          alignItems={'flex-start'}
          sx={{
            paddingLeft: isMobilee ? '0' : '0',
            marginTop: isMobilee ? '1rem' : '0.8rem',
          }}>
          <Swiper
            className='swiper-thumbs'
            onSwiper={(swiper) => !swiper.destroyed && setThumbsSwiper(swiper)}
            slidesPerView={Math.min(visibleThumbnails, mediaAssets.length)}
            watchSlidesProgress
            spaceBetween={9}
            freeMode={false}
            style={{ overflowX: 'hidden', display: 'flex', justifyContent: 'flex-start !important', gap: '9px' }}>
            {mediaAssets.slice(startIndex, startIndex + visibleThumbnails).map((item: any, index: any) => (
              <SwiperSlide
                className='i'
                key={index}
                onClick={() => handleSlideChange(startIndex + index)}
                style={{ width: '64px !important', height: '64px', cursor: 'pointer', gap: '8px', marginRight: '2px' }}>
                {item.type === 'image' ? (
                  <Image
                    src={item.src || ''}
                    alt=''
                    priority
                    fetchPriority='high'
                    unoptimized
                    width={64}
                    height={64}
                    style={{
                      borderRadius: 10,
                      border: activeIndex === startIndex + index ? '2.88px solid #FFFFFF' : 'none',
                      objectFit: 'contain',
                    }}
                  />
                ) : item.type === 'video' ? (
                  <Box position='relative' width={64} height={64} borderRadius={2.5} bgcolor='rgba(255,255,255,0.2)'>
                    <Image
                      src={item.thumb || ''}
                      alt=''
                      priority
                      unoptimized
                      width={64}
                      height={64}
                      style={{
                        borderRadius: 10,
                        border: activeIndex === startIndex + index ? '2.88px solid #FFFFFF' : 'none',
                        objectFit: 'contain',
                      }}
                    />

                    {/* Play Icon for Videos */}
                    {item.type === 'video' && (
                      <Box
                        position='absolute'
                        top='50%'
                        left='50%'
                        sx={{
                          transform: 'translate(-50%, -50%)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: 24,
                          height: 24,
                          borderRadius: '50%',
                        }}>
                        <svg width='46' height='46' viewBox='0 0 46 46' fill='none' xmlns='http://www.w3.org/2000/svg'>
                          <path
                            opacity='0.8'
                            d='M0.5 2.9825C0.5 1.6125 1.6125 0.5 2.9825 0.5H43.0175C44.3875 0.5 45.5 1.6125 45.5 2.9825V43.0175C45.4993 43.6757 45.2376 44.3067 44.7722 44.7722C44.3067 45.2376 43.6757 45.4993 43.0175 45.5H2.9825C2.3241 45.5 1.69267 45.2385 1.22711 44.7729C0.761548 44.3073 0.5 43.6759 0.5 43.0175V2.9825ZM19.555 14.0375C19.4045 13.9371 19.2297 13.8794 19.049 13.8706C18.8684 13.8617 18.6887 13.902 18.5291 13.9872C18.3696 14.0723 18.2361 14.1992 18.1429 14.3542C18.0497 14.5092 18.0003 14.6866 18 14.8675V31.1325C18.0003 31.3134 18.0497 31.4908 18.1429 31.6458C18.2361 31.8008 18.3696 31.9277 18.5291 32.0128C18.6887 32.098 18.8684 32.1383 19.049 32.1294C19.2297 32.1206 19.4045 32.0629 19.555 31.9625L31.7525 23.8325C31.8891 23.7408 32.0011 23.6169 32.0785 23.4717C32.156 23.3266 32.1965 23.1645 32.1965 23C32.1965 22.8355 32.156 22.6734 32.0785 22.5283C32.0011 22.3831 31.8891 22.2592 31.7525 22.1675L19.555 14.0375Z'
                            fill='white'
                          />
                        </svg>
                      </Box>
                    )}
                  </Box>
                ) : item.type === 'audio' ? (
                  <Box
                    sx={{
                      width: 63,
                      height: 63,
                      backgroundColor: '#2196F3',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                      fontSize: '12px',
                      borderRadius: 3,
                      marginRight: '3px',
                      border: activeIndex === startIndex + index ? '2.88px solid #FFFFFF' : 'none',
                    }}>
                    🎵 Audio
                  </Box>
                ) : (
                  <Box
                    sx={{
                      width: 63,
                      height: 63,
                      backgroundColor: '#888',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                      fontSize: '12px',
                      borderRadius: 3,
                      border: activeIndex === startIndex + index ? '2.88px solid #FFFFFF' : 'none',
                    }}>
                    📄 Text
                  </Box>
                )}
              </SwiperSlide>
            ))}
          </Swiper>
          {mediaAssets.length > visibleThumbnails &&
            mediaAssets.length - (startIndex + visibleThumbnails) > 0 &&
            mediaAssets.length > 5 && (
              <SwiperSlide
                style={{
                  width: '64px',
                  height: '64px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '14px',
                  color: '#fff',
                  background: mediaAssets[mediaAssets.length - 1]?.src
                    ? `url(${mediaAssets[mediaAssets.length - 1].src})`
                    : '#555',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  borderRadius: 10,
                  marginLeft: '2px',
                  position: 'relative',
                  overflow: 'hidden',
                }}>
                {/* Dark Overlay for Readability */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(255, 0, 68, 0.5)',
                    borderRadius: '10px',
                  }}
                />
                {/* Display the Count on Top */}
                <Box sx={{ zIndex: 1 }}>{`+${mediaAssets.length - (startIndex + visibleThumbnails)}`}</Box>
              </SwiperSlide>
            )}
        </Box>
      )}
    </>
  );
};

export default MediaSlider;
